"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    DrawerFooter: function() {
        return _index.DrawerFooter;
    },
    drawerFooterClassNames: function() {
        return _index.drawerFooterClassNames;
    },
    renderDrawerFooter_unstable: function() {
        return _index.renderDrawerFooter_unstable;
    },
    useDrawerFooterStyles_unstable: function() {
        return _index.useDrawerFooterStyles_unstable;
    },
    useDrawerFooter_unstable: function() {
        return _index.useDrawerFooter_unstable;
    }
});
const _index = require("./components/DrawerFooter/index");
